import { EditIcon, CloseIcon } from '@chakra-ui/icons';
import {
  Text,
  Link as ChakraLink,
  Flex,
  Tooltip,
  Button,
} from '@chakra-ui/react';

export default ({
  openCategoryModal,
  handleOpenUpdateCategoryModal,
  handleOpenDeleteCategoryModal,
}) => {
  return [
    {
      name: 'Id',
      selector: (row) => row.id,
      sortable: true,
      width: '60px',
      sortField: 'id',
    },
    {
      name: 'Name',
      selector: (row) => row.name,
      sortable: true,
      cell: (row) => (
        <ChakraLink color="blue.500" onClick={() => openCategoryModal(row)}>
          <Text fontWeight={500} as="i">
            {row.name}
          </Text>
        </ChakraLink>
      ),
      sortField: 'name',
    },
    {
      name: 'Description',
      selector: (row) => row.description,
      wrap: true,
      sortable: true,
      format: (row) => (
        <Text py={2}>
          {row.description.length > 150
            ? `${row.description.slice(0, 150)}...`
            : row.description}
        </Text>
      ),
      sortField: 'description',
    },
    {
      name: 'Action',
      sortable: false,
      cell: (row) => (
        <Flex gap={2}>
          <Tooltip label="Edit" fontSize="md">
            <Button
              colorScheme="blue"
              size="xs"
              onClick={() => handleOpenUpdateCategoryModal(row)}
            >
              <EditIcon />
            </Button>
          </Tooltip>
          <Tooltip label="Remove" fontSize="md">
            <Button
              colorScheme="gray"
              size="xs"
              onClick={() => handleOpenDeleteCategoryModal(row)}
            >
              <CloseIcon />
            </Button>
          </Tooltip>
        </Flex>
      ),
    },
  ];
};
